<template>
  <div>
    <PatternHero
      size="medium"
      color-class="text-primary-400"
      icon-for-type="Event"
    >
      <div class="p-6 md:pl-0">
        <h2 class="text-mobile-2xl font-semibold md:text-2xl">
          {{ event.title }}
        </h2>
        <p class="text-shade-500">
          {{ $t('event.media_count', event.medias?.length) }}
        </p>
      </div>
    </PatternHero>
    <div class="mx-auto max-w-7xl px-6 pt-6 md:pt-10 xl:px-0">
      <h3
        class="text-mobile-xl font-semibold first-letter:uppercase md:mt-20 md:text-xl"
      >
        {{ $t('labels.general_information') }}
      </h3>
      <DataDescriptionList :items="informations" class="mt-4" />

      <div class="divide-y divide-shade-200 mt-4">
        <ListResource
          v-if="event.medias?.length > 0"
          v-for="(result, i) in event.medias.map(formatMedia)"
          :key="i"
          :resource="result"
          class="py-4"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from '#i18n'
import { getEventBySlug } from '~/queries/event'

const { t } = useI18n()
const { formatToFullDate } = useFullDateFormater()

const { slug } = useResourceSlug()
const { data, pending, error } = await useAsyncData(`/event/${slug}/`, () =>
  execQuery(getEventBySlug, { slug })
)

const event = computed<VirtualEvent | PhysicalEvent>(() => {
  if (pending.value || error.value) return {}
  return data.value.data.eventBySlug
})
function formatMedia(media) {
  if (!media) return null
  return {
    subtitle: media.description,
    excerpt: `${media.timestamp ? formatToFullDate(media.timestamp) : ''} ${
      media.duration ?? ''
    }`,
    ...media,
  }
}

const informations = computed<DescriptionList>(() => {
  const res = [
    {
      key: t('labels.date'),
      value: formatToFullDate(event.value.start),
    },
  ]
  if (event.value.location) {
    res.push({
      key: t('labels.location'),
      value: `${event.value.location.name}, ${event.value.location.city.name}`,
    })
  }
  if (event.value.programnote?.program) {
    res.push({
      key: t('labels.program_note'),
      value: {
        label: event.value.programnote.title,
        href: event.value.programnote.program.getUrl,
      },
    })
  }
  return res
})
</script>
